import { Box, Typography, makeStyles } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import React from 'react'
import moment from 'moment'

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2)
  },
  texto: {
    marginTop: theme.spacing(0.5)
  }
}))

type Props = {
  dataLimite?: string | null
  bloqueioAtivo?: boolean
  /** Texto voltado ao painel operacional (Super Admin), não ao formulário do seller. */
  variante?: 'formulario' | 'painel'
}

function formatarDataLimite(dataLimite?: string | null) {
  if (!dataLimite) return null
  const data = moment(dataLimite)
  if (!data.isValid()) return null
  return data.format('DD/MM/YYYY')
}

function textoFormulario(dataFormatada: string | null) {
  const prazo = dataFormatada ? ` até ${dataFormatada}` : ''

  return (
    <>
      Para manter seus recebimentos ativos, é necessário atualizar alguns dados
      cadastrais{prazo}. Essa atualização é uma exigência do Banco Central
      (BACEN) e será realizada pela Pagar.me, parceira de pagamentos da SYN.
      <Box component="span" display="block" mt={1}>
        Preencha apenas os campos indicados abaixo. Após a atualização, seus
        recebimentos seguem normalmente.
      </Box>
    </>
  )
}

function textoPainel(dataFormatada: string | null, bloqueioAtivo?: boolean) {
  if (!dataFormatada) {
    return (
      <>
        A data limite ainda não está configurada — o aviso aos sellers é
        dispensável e o bloqueio de acesso não está ativo.
      </>
    )
  }

  if (bloqueioAtivo) {
    return (
      <>
        A data limite para regularização era {dataFormatada} e o bloqueio já
        está ativo. Após o prazo, o acesso à plataforma e os pagamentos ficam
        restritos para quem ainda estiver pendente.
      </>
    )
  }

  return (
    <>
      A data limite para regularização é {dataFormatada}. Após o prazo, o
      acesso à plataforma e os pagamentos ficam restritos para quem ainda
      estiver pendente.
    </>
  )
}

export default function AvisoBacen({
  dataLimite,
  bloqueioAtivo,
  variante = 'formulario'
}: Props) {
  const classes = useStyles()
  const dataFormatada = formatarDataLimite(dataLimite)
  const severity =
    variante === 'painel' && bloqueioAtivo ? 'warning' : 'info'

  if (variante === 'painel') {
    return (
      <Box className={classes.root}>
        <Alert severity={severity}>
          <Typography variant="body2">
            {textoPainel(dataFormatada, bloqueioAtivo)}
          </Typography>
        </Alert>
      </Box>
    )
  }

  return (
    <Box className={classes.root}>
      <Alert severity={severity}>
        <Typography variant="subtitle1" component="h2">
          Atualização cadastral necessária
        </Typography>
        <Typography variant="body2" className={classes.texto}>
          {textoFormulario(dataFormatada)}
        </Typography>
      </Alert>
    </Box>
  )
}
